module.exports = __webpack_public_path__ + "static/media/coupon-bg.4cfed709.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/coupon-bg.png
// module id = 328
// module chunks = 6